export const DEFAULT_META = {
  page: {
    current: 1,
    size: 10,
    total_pages: 0,
    total_results: 0
  }
}
